/* CONCEPTS */
export const MONITOR_TYPE_LOAD = "MONITOR_TYPE_LOAD";
export const MONITOR_TYPE_LOAD_SUCCESS = "MONITOR_TYPE_LOAD_SUCCESS";
export const MONITOR_TYPE_ERROR = "MONITOR_TYPE_ERROR";
export const MONITOR_TYPE_CLEAN = "MONITOR_TYPE_CLEAN";
